import React from 'react';
import axios from 'axios';

const showButton = false;

const CancelToken = axios.CancelToken;
let cancel;

const FetchPipedriveDataButton = () => {
    const fetchPipedriveData = () => {
        fetchData();
    };

    async function fetchData() {
        cancel && cancel();

        const uri = `api/crm/migrate`;

        try {
            axios
                .get(uri, {
                    cancelToken: new CancelToken((c) => {
                        cancel = c;
                    }),
                    headers: {
                        Accept: 'application/json, text/plain, */*',
                        'Content-Type': 'application/json;charset=UTF-8',
                    },
                })
                .then((response) => {
                    console.info('response = ', response.data);
                })
                .catch((thrown) => {
                    alert('error thrown while fetching pipedrive data');
                    if (axios.isCancel(thrown)) {
                        //TODO Something when request is cancelled?
                    } else {
                        //const error = thrown.response;
                    }
                });
        } catch (error) {
            console.error(error);
        }
    }

    if (!showButton) return null;

    return (
        <button type='button' className='btn btn-success crm-modal-btn' onClick={() => fetchPipedriveData()}>
            Transfer Pipedrive to Db
        </button>
    );
};

export default FetchPipedriveDataButton;
